const links = {
  /* google sheets */
  accountingEntries: 'https://docs.google.com/spreadsheets/d/1drzv9PIGvT95pEErk-G3qBIbsCglcJqe2Rs57tzNAxM/edit#gid=2091804413',
  // suppliers
  suppliers: 'https://docs.google.com/spreadsheets/d/1PWiSzYwBYTbrITce380rSW9kQfwxddEk-oQdCH8tAW8/edit#gid=0',
  // coa
  projects: 'https://docs.google.com/spreadsheets/d/1pLC3zXJn_Jjqs8ANR1V_3sj43iLT4DUihiAdyn_2HEc/edit#gid=1192319815',
  costCenters: 'https://docs.google.com/spreadsheets/d/1pLC3zXJn_Jjqs8ANR1V_3sj43iLT4DUihiAdyn_2HEc/edit#gid=1866566110',
  locations: 'https://docs.google.com/spreadsheets/d/1pLC3zXJn_Jjqs8ANR1V_3sj43iLT4DUihiAdyn_2HEc/edit#gid=260122901',
  products: 'https://docs.google.com/spreadsheets/d/1pLC3zXJn_Jjqs8ANR1V_3sj43iLT4DUihiAdyn_2HEc/edit#gid=1018478748',
  // stations
  unifiedStationMaster: 'https://docs.google.com/spreadsheets/d/138f8056W-53xWz-XoSSbHT7UtEydpQamiwF7mMOINC0/edit#gid=565942350',

  /* google forms */
  vendorRequestForm: 'https://sites.google.com/seaoil.com.ph/seaoildataportal/make-a-request/vendor-data-catalog/vendor-enrollment',
};

export default links;
